import { render, staticRenderFns } from "./capital.vue?vue&type=template&id=37967cfc&scoped=true"
import script from "./capital.vue?vue&type=script&lang=js"
export * from "./capital.vue?vue&type=script&lang=js"
import style0 from "./capital.vue?vue&type=style&index=0&id=37967cfc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37967cfc",
  null
  
)

export default component.exports